// src/components/Footer.jsx
import React from "react";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PinterestIcon from "@mui/icons-material/Pinterest";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/logo.svg";

const Footer = () => {
  return (
    <footer className="bg-secondary text-accent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <Link
                to="/"
                className="flex items-center gap-2 group cursor-pointer"
              >
                <Logo className="w-10 h-10" />
                <div className="flex flex-col items-start">
                  <span className="text-primary logoText font-semibold text-xl">
                    MockingJay
                  </span>
                  <span className="text-gray-200 text-xs">
                    WeBuildWhatYouNeed
                  </span>
                </div>
              </Link>
            </div>

            <p className="text-accent/80 leading-relaxed mb-6">
              Our innovative approach ensures seamless integration and
              unparalleled performance, driving your business forward with
              cutting-edge digital solutions.
            </p>

            {/* ✅ Social links: href="#" removed to fix CI build (jsx-a11y/anchor-is-valid) */}
            <div className="flex gap-4">
              <a
                href="https://twitter.com/"
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter"
                className="w-10 h-10 rounded-lg hover:bg-primary hover:text-secondary flex items-center justify-center transition-all duration-200"
              >
                <TwitterIcon className="w-5 h-5" />
              </a>

              <a
                href="https://facebook.com/"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-lg hover:bg-primary hover:text-secondary flex items-center justify-center transition-all duration-200"
              >
                <FacebookIcon className="w-5 h-5" />
              </a>

              <a
                href="https://pinterest.com/"
                target="_blank"
                rel="noreferrer"
                aria-label="Pinterest"
                className="w-10 h-10 rounded-lg hover:bg-primary hover:text-secondary flex items-center justify-center transition-all duration-200"
              >
                <PinterestIcon className="w-5 h-5" />
              </a>

              <a
                href="https://linkedin.com/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-lg hover:bg-primary hover:text-secondary flex items-center justify-center transition-all duration-200"
              >
                <LinkedInIcon className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#vision"
                  className="text-accent hover:text-primary transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-accent rounded-full"></span>
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="text-accent hover:text-primary transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-accent rounded-full"></span>
                  Our Services
                </a>
              </li>
              <li>
                <a
                  href="#projects"
                  className="text-accent hover:text-primary transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-accent rounded-full"></span>
                  Projects
                </a>
              </li>
              <li>
                <a
                  href="#work"
                  className="text-accent hover:text-primary transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-accent rounded-full"></span>
                  Process
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-accent hover:text-primary transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-accent rounded-full"></span>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li className=" hover:text-primary transition-colors duration-200 cursor-pointer">
                Web Development
              </li>
              <li className=" hover:text-primary transition-colors duration-200 cursor-pointer">
                Mobile App Development
              </li>
              <li className=" hover:text-primary transition-colors duration-200 cursor-pointer">
                SEO Optimization
              </li>
              <li className=" hover:text-primary transition-colors duration-200 cursor-pointer">
                Web Scraping & Automation
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Stay Updated</h4>
            <p className=" mb-4">
              Subscribe to our newsletter for the latest insights and updates.
            </p>
            <div className="space-y-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 rounded-lg border border-accent/40 placeholder-accent/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors bg-transparent"
              />
              <button className="w-full px-4 py-3 rounded-lg bg-primary text-secondary font-medium hover:bg-primary/90 transition-colors duration-200 transform hover:scale-105">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary/80 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4 text-sm text-accent/80">
              <span>
                © {new Date().getFullYear()} MockingJay.Tech All rights
                reserved.
              </span>
              <span className="hidden sm:inline">•</span>

              {/* ✅ href="#" removed to fix CI build */}
              <Link
                to="/privacy"
                className="hover:text-primary transition-colors"
              >
                Privacy Policy
              </Link>

              <span className="hidden sm:inline">•</span>

              <Link
                to="/terms"
                className="hover:text-primary transition-colors"
              >
                Terms of Service
              </Link>
            </div>

            <div className="flex items-center gap-2 text-sm text-accent/80">
              <span>Made with</span>
              <span className="text-accent">❤</span>
              <span>by MockingJay.Tech Team</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
